import React, {ChangeEvent, FocusEvent, useEffect, useState} from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { IoCalendarOutline } from 'react-icons/io5';

interface IDatePickerProps {
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
  value?: Date | null; // Optional controlled value
  onBlur?: (date: Date | null) => void;
  onChange?: (date: Date | null) => void;
}

const AppDatePicker: React.FC<IDatePickerProps> = ({
  label,
  placeholder = 'Select Date',
  disabled,
  value,
  required,
 showMonthDropdown=true,
 showYearDropdown=true,
  onBlur,
  onChange,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(value || null);
  const handleDateChange = (date: Date | null) => {
    if (onChange) {
      onChange(date);
    }
  };

  const handleDateBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(selectedDate);
    }
  };

  useEffect(() => {
    setSelectedDate(value ?? null);
  }, [value]);

  return (
    <div>
      {label ? (
        <div className="mb-1 flex items-center gap-2">
          <p className="font-semibold text-xs">{label}</p>
          <p className={`text-red-500 ${required ? '' : 'invisible'}`}>*</p>
        </div>
      ) : null}
      <div className="relative mt-1 w-full">
        <DatePicker
          selected={selectedDate}
          onKeyDown={(e)=>e.preventDefault()}
          onBlur={handleDateBlur}
          onChange={handleDateChange}
          placeholderText={placeholder}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dateFormat="yyyy-MM-dd"
          wrapperClassName="w-full"
          disabled={disabled}
          className={`block w-full  py-2 h-12 px-4 pr-12 rounded-xl text-sm bg-[#FAFAFA] hover:outline-none focus:outline-none`}
        />
        <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
          <IoCalendarOutline className="h-5 w-5 text-gray-400" />
        </span>
      </div>
    </div>
  );
};

export default AppDatePicker;
